export default "__VITE_ASSET__CWhJrxCi__"